import QuestionnaireSelectorEditor from '../../../../FormEditors/QuestionnaireSelectorEditor';

const QuestionnaireSelectorForm = ({ control, questionnaireId }) => {
  return <QuestionnaireSelectorEditor name="questionnaire_id" control={control} questionnaireId={questionnaireId} />;
};

export default QuestionnaireSelectorForm;
